export default [
  {
    value: 'SPECIAL',
    label: 'Special Instructions',
  },
  { value: 'VENDOR', label: 'Vendor Instructions' },
];
